import React, { useCallback } from "react";
import SessionStore from "../../stores/SessionStore";
import Zendesk from "./Zendesk";
import { useDeviceOptionsStore } from "../../storez/DeviceOptionsStore";
import ForethoughtAI from "./ForethoughtAI";
import ZendeskSunshine from "./ZendeskSunshine";

const zendesk = <Zendesk />;
const forethought = <ForethoughtAI />;
const zendeskSunshine = <ZendeskSunshine />;

const ChatWidget = (): JSX.Element => {
  // the device config is loaded in `AppRoot` to avoid multiple fetch calls as that data is required
  // by several components; once the data is available, this view will automatically re-render
  const [deviceOptions] = useDeviceOptionsStore(useCallback((state) => [state.options] as const, []));

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
  if (!SessionStore.isAuthenticated() || !SessionStore.getSelectedDevice()) {
    return <></>;
  }

  if (deviceOptions?.allow_support_zendesk) {
    return zendesk;
  }

  // This flag is replaced by Zendesk Sunshine, as we don't use Snap Engage anymore
  // TODO: to be confirmed with Support - we probably doesn't need to instantiate Zendesk script, if Zendesk Sunshine is enabled
  if (deviceOptions?.allow_support_school_manager) {
    return (
      <>
        {zendeskSunshine}
        {zendesk}
      </>
    );
  }

  if (deviceOptions?.allow_support_forethought_ai) {
    return (
      <>
        {forethought}
        {zendesk}
      </>
    );
  }

  return <></>;
};

export default ChatWidget;
